<div class="ui icon input">
  
  <textarea placeholder="{{placeholder}}" [rows]="rows"
            (blur)="onBlur($event)"
            [(ngModel)]="inputValue" text-display></textarea>
</div>
